import * as React from "react";
import "./filters.scss";
import {option, Option} from "ts-option";
import FilterButton from "./button/FilterButton";
import DropDownWrapper from "../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import FilterButtons from "./FilterButtons";
import Filter, {FilterTypeEnum} from "../../../model/workspace/Filter";
import OptionUtils from "../../../utils/OptionUtils";
import Checkbox from "../../../hiberUiKit/src/atoms/Checkbox/Checkbox";

interface IProps {
	filter: Filter
	onChange: (filter: Filter) => void;
	onRemove: (refreshData: boolean) => void;
	isFilterConfigVisible?: boolean;
	items: string[];
	itemToLabel?: (item: string) => string
}

interface IState {
	/**
	 * Filter value.
	 */
	value: string[];
	/**
	 * Indicates if filter config is visible
	 */
	isFilterConfigVisible: boolean
	/**
	 * Indicates if negation checkbox is selected
	 */
	isNegated: boolean
}

export default class EnumFilter extends React.Component<IProps, IState> {

	constructor(props: IProps) {
		super(props);
		const value = this.props.filter.values as Option<string[]>;
		this.state = {
			value: value.getOrElse([]),
			isFilterConfigVisible: props.isFilterConfigVisible,
			isNegated: props.filter.isNegated()
		};
		this.onCancel = this.onCancel.bind(this);
		this.onDone = this.onDone.bind(this);
	}

	render() {
		return (
			<div>
				<FilterButton filterName={this.props.filter.columnDefinition.label}
							  onRemove={() => this.props.onRemove(true)}
							  onClick={() => this.setState({isFilterConfigVisible: true})}
							  filterValue={this.getDisplayValue()}
							  isDisabled={this.state.isFilterConfigVisible}
							  isNegated={this.props.filter.isNegated()}/>
				{
					this.state.isFilterConfigVisible &&
					<DropDownWrapper width={"auto"} onOutsideClick={this.onCancel}>
						<div className={"c-filter_enum-negation-checkbox"}>
							<Checkbox checked={this.state.isNegated}
									  label={"Is not"}
									  onChange={(value) => this.setState({isNegated: value})}
									  styles={{color: "#112363"}}/>
						</div>
						{this.props.items.map((item, index) => {
							return (
								<div key={index} className="c-filter-string-input-container">
									<Checkbox label={this.itemToLabel(item)}
											  onChange={(isSelected: boolean) => this.onChange(isSelected, item)}
											  checked={this.state.value.indexOf(item) !== -1}
											  styles={{color: "#112363"}}/>
								</div>
							);
						})}
						<FilterButtons onCancel={this.onCancel} onDone={this.onDone} disabled={!this.state.value.length}/>
					</DropDownWrapper>
				}
			</div>
		);
	}

	itemToLabel = this.props.itemToLabel ? this.props.itemToLabel : (item: string) => item.replaceUnderscoresWithSpaces().capitalize();

	onChange = (isSelected: boolean, item: string) => {
		if (isSelected) {
			this.setState({value: this.state.value.concat(item)});
		}
		else {
			this.setState({value: this.state.value.filter(v => v !== item)});
		}
	};

	onCancel() {
		this.setState({isFilterConfigVisible: false},
			() => this.props.filter.values.isEmpty && this.props.onRemove(false));
	}

	onDone() {
		const filterType = this.state.isNegated ? FilterTypeEnum.NotIn : FilterTypeEnum.In;
		this.setState({isFilterConfigVisible: false},
			() => this.isFilterChanged(filterType)
				&& this.props.onChange(this.props.filter.copy({values: option(this.state.value), type: filterType})))
	}

	isFilterChanged(filterType: FilterTypeEnum) {
		return !OptionUtils.isTheSame(this.props.filter.values, option(this.state.value)) || this.props.filter.type !== filterType
	}

	getDisplayValue() {
		return (this.props.filter.values as Option<string[]>).getOrElse([]).map(i => this.itemToLabel(i)).join(", ")
	}
}
